import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';

/**
 * Polls a server-served `/build-info.json` (no-cache) periodically.
 * If the build hash changes (= new deploy), shows a persistent toast
 * with a 'Refresh' button so the user reloads at their convenience.
 *
 * The component renders nothing.
 */
export default function BuildVersionWatcher({ intervalMs = 90000 }) {
  const initial = useRef(null);
  const [warned, setWarned] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      try {
        const res = await fetch('/build-info.json?t=' + Date.now(), {
          cache: 'no-store',
          headers: { 'Cache-Control': 'no-cache' },
        });
        if (!res.ok) return;
        const data = await res.json();
        const hash = data?.buildHash || data?.commit || data?.timestamp || '';
        if (!hash) return;
        if (cancelled) return;
        if (initial.current == null) {
          initial.current = hash;
        } else if (hash !== initial.current && !warned) {
          setWarned(true);
          toast.message('Versi baru aplikasi sudah tersedia', {
            description: 'Refresh halaman untuk menggunakan versi terbaru.',
            duration: Infinity,
            action: {
              label: 'Refresh sekarang',
              onClick: () => window.location.reload(true),
            },
          });
        }
      } catch (_e) {
        /* silent */
      }
    };

    check();
    const id = setInterval(check, intervalMs);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [intervalMs, warned]);

  return null;
}
